import { render, staticRenderFns } from "./ThkMaterialZhuansuList.vue?vue&type=template&id=0ce1af96&scoped=true"
import script from "./ThkMaterialZhuansuList.vue?vue&type=script&lang=js"
export * from "./ThkMaterialZhuansuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce1af96",
  null
  
)

export default component.exports